<template>
  <div class="item-loading block" :style="{ width: width + '%', height: width + '%' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "fakeBlock",
  props: {
    width: {
      type: String,
      default: "50"
    },
    cHeight: {
      type: String,
      default: "50"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.block {
  flex-shrink: 0;
  padding: 0 !important;
}
</style>
